import Agilite from 'agilite'
import store from '../../../store'
import { pdfGenerationEnums as pdfGenEnums } from '../../Examination/components/Documents/utils/enums'
import { blobToBase64 } from '../../lib/utils'
import dayjs from 'dayjs'

const agilite = new Agilite({
  apiServerUrl: process.env.REACT_APP_AGILITE_API_URL,
  apiKey: process.env.REACT_APP_AGILITE_API_KEY
})

// Diagnosis utility functions
export const downloadScript = async (items, signature, clinicDetails, patientData) => {
  console.log('📄 downloadScript called with:', {
    itemsCount: items?.length,
    items: items,
    firstItem: items?.[0],
    firstItemKeys: items?.[0] ? Object.keys(items[0]) : [],
    hasSignature: !!signature,
    hasClinicDetails: !!clinicDetails,
    hasPatientData: !!patientData,
    patientName: patientData ? `${patientData.firstName} ${patientData.lastName}` : 'N/A'
  })

  // Log the structure of each medication item
  if (items && items.length > 0) {
    console.log('📄 Medication items structure:')
    items.forEach((item, index) => {
      console.log(`  Item ${index + 1}:`, {
        tradeName: item.tradeName,
        description: item.description,
        scriptingDosage: item.scriptingDosage,
        quantity: item.quantity,
        keys: Object.keys(item)
      })
    })
  }

  try {
    const authUser = store.getState().auth.agiliteUser

    // Format medications for CraftMyPDF template
    const formattedMedications = (items || []).map((item, index) => ({
      index: index + 1,
      name: item.tradeName || item.name || '',
      description: item.description || item.fullDescription || '',
      dosage: item.scriptingDosage || item.dosage || '',
      quantity: item.quantity || '',
      route: item.route || '',
      schedule: item.schedule || '',
      drugSchedule: item.drugSchedule || '',
      strengthMetric1: item.strengthMetric1 || '',
      unitOfMeasure1: item.unitOfMeasure1 || '',
      presentationCode: item.presentationCode || '',
      standardPacksize: item.standardPacksize || '',
      dispensingVolumePacksize: item.dispensingVolumePacksize || '',
      // Combine relevant fields into a display string
      displayText: `${item.tradeName || item.name || ''} ${item.strengthMetric1 || ''} ${item.unitOfMeasure1 || ''} ${item.presentationCode || ''} - ${item.scriptingDosage || ''} x ${item.quantity || ''}`
    }))

    // Prepare template data for CraftMyPDF
    const templateData = {
      patientName: `${patientData.firstName} ${patientData.lastName}`,
      idNo: patientData.idNo || '',
      phoneNumber: patientData.phoneNumber || '',
      medAidName: patientData.medicalAid?.name || '',
      medAidPlan: patientData.medicalAid?.plan || '',
      medAidNumber: patientData.medicalAid?.number || '',
      dependantNumber: patientData.medicalAid?.dependantNumber || '',
      date: dayjs(new Date()).format('DD MMM YYYY'),
      practiceName: clinicDetails?.practiceName || '',
      practiceNo: clinicDetails?.practiceNumber || '',
      regNo: clinicDetails?.practiceRegNumber || '',
      clinicAddress: clinicDetails?.address || '',
      clinicPhone: clinicDetails?.phoneNumber || '',
      medications: formattedMedications,
      medProfName: `${authUser.firstName} ${authUser.lastName}`,
      mpNumber: authUser.extraData?.mpNumber || '',
      qualification: authUser.extraData?.qualification || '',
      entityLogo: store.getState().core.entity?.entityLogo?.split(',')[1] || '',
      entityIcon: store.getState().core.entity?.entityIcon?.split(',')[1] || '',
      signatureData: signature?.split(',')[1] || signature || ''
    }

    console.log('📄 Template data prepared:', {
      hasPatientName: !!templateData.patientName,
      hasMedications: !!templateData.medications.length,
      medicationsCount: templateData.medications.length,
      medications: templateData.medications,
      firstMedication: templateData.medications[0],
      hasSignature: !!templateData.signatureData,
      signatureLength: templateData.signatureData?.length
    })

    console.log('📄 Full template data being sent to CraftMyPDF:', JSON.stringify(templateData, null, 2))

    // Call CraftMyPDF API
    const pdfResponse = await agilite.Connectors.execute(
      pdfGenEnums.pdfGeneration.CRAFT_MY_PDF,
      pdfGenEnums.pdfGeneration.CREATE_SCRIPT,
      {
        data: JSON.stringify(templateData)
      }
    )

    console.log('📄 CraftMyPDF response:', {
      status: pdfResponse?.data?.status,
      hasFile: !!pdfResponse?.data?.file,
      fileUrl: pdfResponse?.data?.file,
      fullResponse: pdfResponse?.data
    })

    if (pdfResponse.data && pdfResponse.data.status === 'success') {
      // Convert the PDF URL to base64
      const response = await fetch(pdfResponse.data.file)
      const blob = await response.blob()
      const base64data = await blobToBase64(blob)

      console.log('📄 PDF converted to base64:', {
        blobSize: blob.size,
        base64Length: base64data?.length,
        startsWithDataPrefix: base64data?.startsWith('data:'),
        first100Chars: base64data?.substring(0, 100)
      })

      return base64data
    } else {
      console.error('📄 PDF generation failed:', pdfResponse.data)
      throw new Error('Error generating PDF: ' + (pdfResponse.data?.message || 'Unknown error'))
    }
  } catch (error) {
    console.error('📄 downloadScript error:', {
      error,
      message: error.message,
      stack: error.stack
    })
    throw error
  }
}

export const downloadReferralLetter = async (data) => {
  console.warn('downloadReferralLetter function needs to be implemented for your specific API')
  return 'data:application/pdf;base64,placeholder'
}

export const downloadSickLeave = async (data) => {
  console.warn('downloadSickLeave function needs to be implemented for your specific API')
  return 'data:application/pdf;base64,placeholder'
}

// PDF Generation enums
export const pdfGenerationEnums = {
  profileKeys: {
    PATIENTS: 'patients'
  },
  routeKeys: {
    CREATE: 'create',
    READ: 'read',
    UPDATE: 'update',
    DELETE: 'delete'
  }
}

export default {
  downloadScript,
  downloadReferralLetter,
  downloadSickLeave,
  pdfGenerationEnums
}
